import { useState } from 'react';
import Hero from './components/Hero';
import Problem from './components/Problem';
import Affinity from './components/Affinity';
import Solution from './components/Solution';
import Benefit from './components/Benefit';
import Evidence from './components/Evidence';
import SocialProof from './components/SocialProof';
import Scenes from './components/Scenes';
import Trust from './components/Trust';
import Offer from './components/Offer';
import Closing from './components/Closing';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

export default function Home() {
  const [isNavbarFixed, setIsNavbarFixed] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 100) {
      setIsNavbarFixed(true);
    } else {
      setIsNavbarFixed(false);
    }
  };

  if (typeof window !== 'undefined') {
    window.addEventListener('scroll', handleScroll);
  }

  return (
    <div className="relative">
      <Navbar isFixed={isNavbarFixed} />
      <Hero />
      <Problem />
      <Affinity />
      <Solution />
      <Benefit />
      <Evidence />
      <SocialProof />
      <Scenes />
      <Trust />
      <Offer />
      <Closing />
      <Footer />
    </div>
  );
}